module.exports = __webpack_public_path__ + "media/images/cc-logo-dark-ff5db883.png";